import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Usuario } from '@/shared/types/api.types';
import type { AplicacionDto } from '@/shared/types/tenant';

// [AUD-3.2] Tokens removidos del store — ahora viajan como HttpOnly cookies
// Solo se persiste la info del usuario para la UI

interface AuthState {
  user: Usuario | null;
  isAuthenticated: boolean;
  activeApp: AplicacionDto | null;
  availableApps: AplicacionDto[];
}

interface AuthActions {
  setAuth: (user: Usuario) => void;
  clearAuth: () => void;
  setActiveApp: (app: AplicacionDto) => void;
  setAvailableApps: (apps: AplicacionDto[]) => void;
}

type AuthStore = AuthState & AuthActions;

export const useAuthStore = create<AuthStore>()(
  persist(
    set => ({
      user: null,
      isAuthenticated: false,
      activeApp: null,
      availableApps: [],

      setAuth: user =>
        set({
          user,
          isAuthenticated: true,
          availableApps: user.aplicaciones ?? [],
        }),

      clearAuth: () =>
        set({
          user: null,
          isAuthenticated: false,
          activeApp: null,
          availableApps: [],
        }),

      setActiveApp: app => set({ activeApp: app }),

      setAvailableApps: apps => set({ availableApps: apps }),
    }),
    {
      name: 'auth-storage',
    }
  )
);
